/* eslint-disable */

export const sentVolumeBuy = {
    GET_SENT_VOLUME_BUY_REQUEST: 'GET_SENT_VOLUME_BUY_REQUEST',
    GET_SENT_VOLUME_BUY_SUCCESS: 'GET_SENT_VOLUME_BUY_SUCCESS',
    GET_SENT_VOLUME_BUY_FAILURE: 'GET_SENT_VOLUME_BUY_FAILURE',
};
